import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Sparkles, X, ArrowRight, ScanLine, ScanSearch, Scale, Cpu, Factory, ClipboardList, Truck } from "lucide-react";

const RED = "#e01414";
const TRY = [
  { icon: ScanLine, label: "AI Purchase Order Reader", to: "/enquiries" },
  { icon: ScanSearch, label: "AI Product & Mould Finder", to: "/ai/product-finder" },
  { icon: Scale, label: "AI Weight Calculator", to: "/ai/weight-calculator" },
  { icon: Cpu, label: "AI Tooling Engineer", to: "/ai/mould-cost-estimator" },
  { icon: Factory, label: "Production Planning", to: "/production" },
  { icon: ClipboardList, label: "Work Orders", to: "/work-orders" },
  { icon: Truck, label: "Dispatch", to: "/dispatch" },
];

export default function DemoOverlay() {
  const { isDemo } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(isDemo && localStorage.getItem("ff_demo_welcome_seen") !== "1");
  if (!isDemo) return null;

  const close = () => { localStorage.setItem("ff_demo_welcome_seen", "1"); setOpen(false); };
  const tryNow = (to) => { close(); nav(to); };

  return (
    <>
      <div data-testid="demo-banner" className="bg-black text-white px-4 py-1.5 flex items-center justify-center gap-2 text-xs font-medium border-b border-white/10">
        <span className="inline-flex items-center gap-1.5" style={{ color: RED }}><Sparkles size={13} /> Demo Workspace</span>
        <span className="text-slate-400">· Apex Rubber Components · Sample Data Only</span>
      </div>

      {open && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" data-testid="demo-welcome">
          <div className="w-full max-w-lg bg-[#0c0c0c] border border-white/10 rounded-2xl overflow-hidden">
            <div className="p-6 border-b border-white/5 relative">
              <button onClick={close} data-testid="demo-welcome-close" className="absolute top-4 right-4 text-slate-500 hover:text-white"><X size={18} /></button>
              <div className="inline-flex items-center gap-2 text-xs font-medium text-slate-300 border border-white/10 rounded-full px-3 py-1 mb-3 bg-white/5"><Sparkles size={13} style={{ color: RED }} /> Interactive Demo</div>
              <h2 className="text-2xl font-bold text-white">Welcome to <span className="text-white">Factory</span><span style={{ color: RED }}>Flow</span></h2>
              <p className="text-sm text-slate-400 mt-2 leading-relaxed">This interactive demo showcases how FactoryFlow helps manufacturing companies manage their complete workflow using AI. Explore freely — or jump straight into a feature:</p>
            </div>
            <div className="p-4 grid sm:grid-cols-2 gap-2 max-h-[45vh] overflow-y-auto">
              {TRY.map((t) => (
                <button key={t.label} onClick={() => tryNow(t.to)} data-testid={`demo-try-${t.to.replace(/\//g, "-")}`}
                  className="group flex items-center gap-3 text-left border border-white/8 rounded-xl px-3 py-3 hover:border-white/25 hover:bg-white/[0.03] transition-colors">
                  <div className="w-9 h-9 rounded-lg grid place-items-center shrink-0" style={{ background: "rgba(224,20,20,0.12)" }}><t.icon size={16} style={{ color: RED }} /></div>
                  <span className="text-sm text-slate-200 flex-1">{t.label}</span>
                  <ArrowRight size={14} className="text-slate-500 group-hover:translate-x-0.5 transition-transform" />
                </button>
              ))}
            </div>
            <div className="p-4 border-t border-white/5 flex justify-end">
              <button onClick={close} data-testid="demo-explore-freely" className="text-sm font-semibold text-white px-5 h-10 rounded-lg" style={{ background: RED }}>Explore freely</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
